export const dietryList = [
    { key: "0", name: "Health Options" },
    { key: "10665", name: "Vegetarian Friendly" },
    { key: "10697", name: "Vegan Options" },
    { key: "10992", name: "Gluten Free Options" }
]